import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Card, Text } from '../../Atoms';
function TemplateListDocument(props) {
  return (
    <div className="template-document template-send-document template-scroll">
      <Text text="Mes documents" className="title-document" />
      <Text
        text="Selectionnez le type de documents que vous souhaitez visualiser ou télécharger :"
        type="h6"
        className="list-document"
        style={{ textAlign: 'center' }}
      />
      <Row>
        {props.data.map((el, index) => {
          return (
            <Col key={index} className="container-card-document" md={4} xs={6}>
              <Card
                text={el.name}
                onClick={() =>
                  props.onChangeRoute(
                    el.route || `documents/listDocument/${el.name}`,
                    el
                  )
                }
              />
            </Col>
          );
        })}
      </Row>
    </div>
  );
}

TemplateListDocument.defaultProps = {
  onChangeRoute: null
};
export default TemplateListDocument;
